import { Fragment, useState } from 'react'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faFacebook, faYoutube, faInstagram, faFacebookF } from '@fortawesome/free-brands-svg-icons'
import { faShareNodes, faFont, faGlobe } from '@fortawesome/free-solid-svg-icons'
import { useTranslation } from 'react-i18next';
import { useSearchParams, useLocation, useNavigate } from 'react-router-dom'

import Social from './Social'
import Popover from './Popover'
import PopoverLang from './PopoverLang'

export default function Header(props) {
    const [isSocialOpen, setIsSocialOpen] = useState(false);
    const { i18n, t } = useTranslation(['booking']);
    const location = useLocation();
    const navigate = useNavigate();
    const [searchParams] = useSearchParams();

    const lang = (lng) => {
        i18n.changeLanguage(lng);
    };

    if (searchParams.get('lang')) {
        if (['en', 'tc', 'sc'].includes(searchParams.get('lang'))) {
            lang(searchParams.get('lang'));
            searchParams.delete('lang');
        }
    }

    const navigateToHome = async () => {
        if (location.pathname === "/reservation") {
            if (props.selectedSession) {
                if (window.confirm(t('misc.prompt-alert', { ns: 'booking' }))) {
                    return navigate(`/`);
                }
            } else {
                return navigate(`/`);
            }
        } else {
            return navigate(`/`);
        }
    }

    return (
        <Fragment>
            <Social
                isOpen={isSocialOpen}
                setIsOpen={setIsSocialOpen}
                title={props.title}
            />
            <section id="top">
                <div className='lg:flex lg:justify-between'>
                    <div className="flex px-4">
                        <a tabIndex="-1" href={`https://www.wsd.gov.hk/${i18n.language}/home/index.html`} target="_blank">
                            <div className="flex flex-none items-center h-16 pr-3">
                                {i18n.language === 'en' && <img className="w-72" src="/img/wsd-logo.png" alt="Water Supplies Department Home" />}
                                {i18n.language === 'tc' && <img className="w-36" src="/img/wsd-logo-tc.png" alt="Water Supplies Department Home" />}
                                {i18n.language === 'sc' && <img className="w-36" src="/img/wsd-logo-sc.png" alt="Water Supplies Department Home" />}
                            </div></a>

                        <div onClick={(e) => navigateToHome(e)} className="cursor-pointer flex flex-none items-center h-16">
                            <div className="px-3 border-l-2 border-gray-100">
                                <img className="w-10" src="/img/logo-ssp-reservoir.png" alt="Ex-Sham Shui Po Service Reservoir Self-guided Tour Booking System" />
                            </div>
                        </div>
                    </div>

                    <div className="flex px-4 justify-center h-16">

                        <div className="flex flex-none items-center px-1">
                            <div className="pl-2 ">
                                <a tabIndex="-1" aria-label="Facebook (Open In New Window)" href={`https://www.facebook.com/watersavedave.hk`} target="_blank">
                                    <div className="px-[11px] py-1 border-[1px] border-wsd rounded-full bg-wsd text-white font-meidum">
                                        <FontAwesomeIcon icon={faFacebookF} alt="Facebook (Open In New Window)" />
                                    </div>
                                </a>
                            </div>
                        </div>

                        <div className="flex flex-none items-center px-1">
                            <a tabIndex="-1" aria-label="Youtube (Open In New Window)" href={`https://www.youtube.com/channel/UCBNvKbiFPLoawj7rZeDInmw`} target="_blank">
                                <div className="px-[8px] py-1 border-[1px] border-red-600 rounded-full bg-red-600 text-white font-meidum">
                                    <FontAwesomeIcon icon={faYoutube} alt="Youtube (Open In New Window)" />
                                </div>
                            </a>
                        </div>

                        <div className="flex flex-none items-center px-1">
                            <a tabIndex="-1" aria-label="Instagram (Open In New Window)" href={`https://www.instagram.com/watersavedave.hk/`} target="_blank">
                                <div className="px-[9px] py-1 border-[1px] border-purple-700 rounded-full bg-purple-700 text-white font-meidum focus:bg-wsd focus:text-white">
                                    <FontAwesomeIcon icon={faInstagram} alt="Instagram (Open In New Window)" />
                                </div>
                            </a>
                        </div>

                        <div className="flex flex-none items-center pl-1">
                            <div className="px-1 border-l-2 border-gray-100">
                                <Popover />
                            </div>
                        </div>

                        <div className="flex flex-none items-center">
                            <div className="px-1">
                                <PopoverLang />
                            </div>
                        </div>
                        {/* <div className="cursor-pointer flex flex-none items-center px-1" onClick={() => lang('en')}>
                            <div className={`${i18n.language === 'en' ? 'bg-wsd text-white' : 'bg-gray-200 text-wsd'} px-2 py-1 border-1 rounded-full font-meidum`}>
                                EN
                            </div>
                        </div>
                        <div className="cursor-pointer flex flex-none items-center px-1" onClick={() => lang('tc')}>
                            <div className={`${i18n.language === 'tc' ? 'bg-wsd text-white' : 'bg-gray-200 text-wsd'} px-2 py-1 border-1 rounded-full font-meidum`}>
                                繁
                            </div>
                        </div>
                        <div className="cursor-pointer flex flex-none items-center px-1" onClick={() => lang('sc')}>
                            <div className={`${i18n.language === 'sc' ? 'bg-wsd text-white' : 'bg-gray-200 text-wsd'} px-2 py-1 border-1 rounded-full font-meidum`}>
                                簡
                            </div>
                        </div> */}

                        <div className="flex flex-none items-center px-1">
                            <a tabIndex="-1" aria-label="Text Size Change Guide (Open In New Window)" href={`https://www.gov.hk/${i18n.language}/about/textsize`} target="_blank">
                                <div className="px-2 py-1 rounded-full border-[1px] border-wsd bg-wsd text-white font-meidum focus:bg-wsd focus:text-white">
                                    <FontAwesomeIcon icon={faFont} alt="Text Size Change Guide (Open In New Window)" />
                                </div>
                            </a>
                        </div>

                        {/* <div className="cursor-pointer flex flex-none items-center px-1">
                            <div className="pl-2 ">
                                <div onClick={() => setIsSocialOpen(true)} className="px-2 py-1 border-1 rounded-full bg-gray-200 text-wsd font-meidum focus:bg-wsd focus:text-white">
                                    <FontAwesomeIcon icon={faShareNodes} alt="Open Up The Page Sharing Dialog" />
                                </div>
                            </div>
                        </div> */}
                    </div>
                </div>
            </section>
        </Fragment>
    );
}